import { useEffect, useState } from 'react';

export const useKeyPress = function(targetKey: string): boolean {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const downHandler = ({ key } : {key : string}) => {
      if (key === targetKey) {
        setKeyPressed(true);
      }
    };
  
    const upHandler = ({ key } : {key : string}) => {
      if (key === targetKey) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey]);

  return keyPressed;
};
